import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState, Settings } from 'editor/src/store/editor/types';

const setDefaultSettingsValueReducer = <K extends keyof Settings>(
  state: EditorState,
  action: PayloadAction<{ property: K; value: Settings[K] }>,
) => {
  const { property, value } = action.payload;
  state.defaultSettings[property] = value;
};

export default setDefaultSettingsValueReducer;
